import {
    IMPORT_P4_GET_ACCOUNT_BY_PX_REQUEST,
    IMPORT_P4_GET_ACCOUNT_BY_PX_RESULT,
    IMPORT_P4_NEW_MIGRATION_OPEN_MODAL,
    IMPORT_P4_SEARCH_ACCOUNTS_REQUEST,
    IMPORT_P4_SEARCH_ACCOUNTS_RESULT,
    IMPORT_P4_GET_ACCOUNT_REQUEST,
    IMPORT_P4_GET_ACCOUNT_RESULT,
    IMPORT_P4_GET_STATUS_REQUEST,
    IMPORT_P4_GET_STATUS_RESULT,
    IMPORT_P4_IMPORT_REQUEST,
    IMPORT_P4_IMPORT_RESULT,
} from 'Redux/actionTypes';

export const accountsImportOpenModal = (open) => ({
    type: IMPORT_P4_NEW_MIGRATION_OPEN_MODAL,
    payload: open
})

export const accountsImportSearchAccountRequest = (data) => ({
    type: IMPORT_P4_SEARCH_ACCOUNTS_REQUEST,
    payload: data
})

export const accountsImportSearchAccountResult_DEL = (result) => ({
    type: IMPORT_P4_SEARCH_ACCOUNTS_RESULT,
    payload: result
})

export const accountsImportGetAccountRequest = (data) => ({
    type: IMPORT_P4_GET_ACCOUNT_REQUEST,
    payload: data
})

export const accountsImportGetAccountResult = (result) => ({
    type: IMPORT_P4_GET_ACCOUNT_RESULT,
    payload: result
})

export const accountsImportRequest = (data) => ({
    type: IMPORT_P4_IMPORT_REQUEST,
    payload: data
})

export const accountsImportResult = (result) => ({
    type: IMPORT_P4_IMPORT_RESULT,
    payload: result
})

export const accountsGetStatusRequest = (data) => ({
    type: IMPORT_P4_GET_STATUS_REQUEST,
    payload: data
})

export const accountsGetStatusResult = (result) => ({
    type: IMPORT_P4_GET_STATUS_RESULT,
    payload: result
})

export const accountsGetAccountByPxRequest = (data) => ({
    type: IMPORT_P4_GET_ACCOUNT_BY_PX_REQUEST,
    payload: data
})

export const accountsGetAccountByPxResult = (data) => ({
    type: IMPORT_P4_GET_ACCOUNT_BY_PX_RESULT,
    payload: data
})